import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Mention } from '../../../domain/mention';
import { DatePropertyTimezonePipe } from '../../../pipes/date-property-timezone.pipe';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@Component({
   selector: 'app-dashboard-mentions-summary',
   standalone: true,
   imports: [CommonModule, DatePropertyTimezonePipe, DashboardCardComponent],
   templateUrl: './mentions-summary.component.html',
   styleUrls: ['./mentions-summary.component.scss']
})
export class MentionsSummaryComponent {
   @Input() mentions: Mention[] = [];

   @Output() viewMention = new EventEmitter<Mention>();
   @Output() viewAll = new EventEmitter<void>();

   expandedComments = new Set<Mention>();

   get latestMentions(): Mention[] {
      return [...this.mentions]
         .sort((a, b) => this.getMentionTime(b) - this.getMentionTime(a))
         .slice(0, 3);
   }

   onViewMention(mention: Mention): void {
      this.viewMention.emit(mention);
   }

   onViewAll(): void {
      this.viewAll.emit();
   }

   isCommentLong(mention: Mention): boolean {
      return this.getCommentWords(mention).length > 10;
   }

   isCommentExpanded(mention: Mention): boolean {
      return this.expandedComments.has(mention);
   }

   getCommentPreview(mention: Mention): string {
      const words = this.getCommentWords(mention);

      if (words.length <= 10) {
         return mention.commentText ?? '';
      }

      return words.slice(0, 10).join(' ');
   }

   toggleComment(mention: Mention): void {
      if (this.expandedComments.has(mention)) {
         this.expandedComments.delete(mention);
         return;
      }

      this.expandedComments.add(mention);
   }

   private getCommentWords(mention: Mention): string[] {
      return (mention.commentText ?? '').trim().split(/\s+/).filter(Boolean);
   }

   private getMentionTime(mention: Mention): number {
      if (!mention.createdDate) {
         return 0;
      }

      const value = new Date(mention.createdDate as any).getTime();

      return Number.isNaN(value) ? 0 : value;
   }
}
